import type { TemplateFormLanguage } from '../types/templateForms';
import { DEFAULT_TEMPLATE_FORM_LANGUAGE } from './constants';

export interface RetainerTranslations {
    signatureStatusTitle: string;
    table: {
        downloadDocument: string;
        clientName: string;
        accepted: string;
        signedDate: string;
    };
    legalDocument: {
        title: string;
        retry: string;
        /** Label shown in bold, e.g. "Step 1:" */
        step1Label: string;
        step1Instruction: string;
        /** Label shown in bold, e.g. "Step 2:" */
        step2Label: string;
        step2Instruction: string;
        clientFullName: string;
        agreementCheckbox: string;
        signature: string;
        date: string;
        next: string;
        signError: string;
        disabledReasons: {
            enterName: string;
            documentLoading: string;
            documentNotReady: string;
        };
    };
}

const ENGLISH_TRANSLATIONS: RetainerTranslations = {
    signatureStatusTitle: 'Signature Completion Status',
    table: {
        downloadDocument: 'Download Document',
        clientName: 'Client Name',
        accepted: 'Accepted',
        signedDate: 'Signed Date',
    },
    legalDocument: {
        title: 'Document Preview',
        retry: 'Retry',
        step1Label: 'Step 1:',
        step1Instruction:
            'Enter your full name below and check the box confirming you read the agreement.',
        step2Label: 'Step 2:',
        step2Instruction: 'Click the "Next" button below.',
        clientFullName: 'Client Full Name',
        agreementCheckbox: 'I confirm that I have read and agree to the terms of these agreements.',
        signature: 'Signature',
        date: 'Date',
        next: 'Next',
        signError: 'Something went wrong while signing the document. Please try again.',
        disabledReasons: {
            enterName: 'Please enter your name',
            documentLoading: 'Document is loading',
            documentNotReady: 'Document must load before you can sign',
        },
    },
};

const FRENCH_TRANSLATIONS: RetainerTranslations = {
    signatureStatusTitle: 'État d’avancement des signatures',
    table: {
        downloadDocument: 'Télécharger le document',
        clientName: 'Nom du client',
        accepted: 'Accepté',
        signedDate: 'Date de signature',
    },
    legalDocument: {
        title: 'Aperçu du document',
        retry: 'Réessayer',
        step1Label: 'Étape 1 :',
        step1Instruction:
            'Entrez votre nom complet ci-dessous et cochez la case confirmant que vous avez lu l’entente.',
        step2Label: 'Étape 2 :',
        step2Instruction: 'Cliquez sur le bouton « Suivant » ci-dessous.',
        clientFullName: 'Nom complet du client',
        agreementCheckbox: 'Je confirme avoir lu et accepté les conditions de ces ententes.',
        signature: 'Signature',
        date: 'Date',
        next: 'Suivant',
        signError:
            'Une erreur s’est produite lors de la signature du document. Veuillez réessayer.',
        disabledReasons: {
            enterName: 'Veuillez entrer votre nom',
            documentLoading: 'Le document est en cours de chargement',
            documentNotReady: 'Le document doit être chargé avant que vous puissiez signer',
        },
    },
};

export const RETAINER_TRANSLATIONS: Record<TemplateFormLanguage, RetainerTranslations> = {
    en: ENGLISH_TRANSLATIONS,
    fr: FRENCH_TRANSLATIONS,
};

export function getRetainerTranslations(
    language: TemplateFormLanguage = DEFAULT_TEMPLATE_FORM_LANGUAGE,
): RetainerTranslations {
    return RETAINER_TRANSLATIONS[language] ?? RETAINER_TRANSLATIONS.en;
}
